import { CANCELAR, SET_ERROR_TELA } from "../actions.type";
import { Solicitante } from "../../model/Solicitante";
import {
  SET_DADOS_SOLICITANTE_CONFIRMAR,
  ACTIVE_CADASTRO,
  SET_ERROR_TELA_BUSCA,
  CLEAN_SOLICITANTE,
  CLEAN_REGISTRO,
  CLEAN_PESQUISA
} from "../mutations.type";

const INITIAL_STATE = {
  solicitante: Solicitante,
  cadastroCanActive: false,
  dadosSolicitanteAConfirmar: false,
  errorTelaInicial: ""
};

export const state = Object.assign({}, INITIAL_STATE);

export const getters = {};

export const actions = {
  [SET_ERROR_TELA]: ({ commit }) => {
    commit(SET_ERROR_TELA_BUSCA, "");
  },

  [CANCELAR]: ({ commit }) => {
    commit(ACTIVE_CADASTRO, false);
    commit(SET_DADOS_SOLICITANTE_CONFIRMAR, false);
    commit(CLEAN_SOLICITANTE);
    commit(CLEAN_REGISTRO);
    commit(CLEAN_PESQUISA);
    commit(SET_ERROR_TELA_BUSCA, "");
  }
};

export const mutations = {
  [CLEAN_PESQUISA]: state => {
    state.errorTelaInicial = "";
  },

  [CLEAN_SOLICITANTE]: state => {
    state.solicitante = Solicitante;
  },

  [ACTIVE_CADASTRO]: (state, solicitante) => {
    solicitante !== null && solicitante.nome === null
      ? (state.cadastroCanActive = true)
      : (state.cadastroCanActive = false);
  },

  [SET_DADOS_SOLICITANTE_CONFIRMAR]: (state, dadosSolicitanteAConfirmar) => {
    state.dadosSolicitanteAConfirmar = dadosSolicitanteAConfirmar;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
